module.exports = __webpack_public_path__ + "static/factfulness-f6fa7eb8c0f0e86611f4a892aaaaad9f.jpg";